import { SchoolLookupAddress } from '@/api/lookups/schoolLookup';
import { StyledSchoolLookup } from './PayinSchoolLookup.styles';

interface SchoolLookupProps {
  onSelect: (result: SchoolLookupAddress) => void;
}

function PayinSchoolLookup({ onSelect }: SchoolLookupProps) {
  return (
    <StyledSchoolLookup onSelect={onSelect} dropdownInstruction={null} hideBorder label="Enter the name or postcode of your organisation" />
  );
}

export default PayinSchoolLookup;
